import { render, staticRenderFns } from "./chooseCombo.vue?vue&type=template&id=5f1ca65e&scoped=true"
import script from "./chooseCombo.vue?vue&type=script&lang=js"
export * from "./chooseCombo.vue?vue&type=script&lang=js"
import style0 from "./chooseCombo.vue?vue&type=style&index=0&id=5f1ca65e&prod&lang=scss&scoped=true"
import style1 from "./chooseCombo.vue?vue&type=style&index=1&id=5f1ca65e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ca65e",
  null
  
)

export default component.exports